/**
 * Keyboard event key constants
 * Used for consistent keyboard event handling across the application
 */
const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  TAB: 'Tab',
} as const;

export default KEYBOARD_KEYS;
